module.exports = __webpack_public_path__ + "static/media/Ronnie.3cfd69fe.jpg";